// routes
import {
  PATH_DASHBOARD,
  PATH_PAGE,
  PATH_AUTH,
  PATH_DOCS
} from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: 22, height: 22 }}
  />
);

const ICONS = {
  map: getIcon('ic_map'),
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  page: getIcon('ic_page'),
  user: getIcon('ic_user'),
  copy: getIcon('ic_copy'),
  error: getIcon('ic_error'),
  charts: getIcon('ic_charts'),
  editor: getIcon('ic_editor'),
  upload: getIcon('ic_upload'),
  animate: getIcon('ic_animate'),
  calendar: getIcon('ic_calendar'),
  elements: getIcon('ic_elements'),
  carousel: getIcon('ic_carousel'),
  language: getIcon('ic_language'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  components: getIcon('ic_components'),
  authenticator: getIcon('ic_authenticator'),
  business: getIcon('ic_business'),
  branch: getIcon('ic_map'),
  document: getIcon('ic_book'),
  system: getIcon('ic_cog')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'dashboard',
        href: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
        isAdmin: false
      },
      {
        title: 'analytics / reports',
        href: PATH_DASHBOARD.general.analytics,
        icon: ICONS.analytics,
        isAdmin: false
      }
    ]
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'admin',
    items: [
      {
        title: 'user',
        icon: ICONS.user,
        href: PATH_DASHBOARD.user.root,
        isAdmin: false,
        items: [
          {
            title: 'create',
            href: PATH_DASHBOARD.user.create,
            isAdmin: true
          },
          {
            title: 'list',
            href: PATH_DASHBOARD.user.list,
            isAdmin: true
          },
          {
            title: 'account',
            href: PATH_DASHBOARD.user.account,
            isAdmin: false
          }
        ]
      },
      // COMPANIES
      {
        title: 'companies',
        icon: ICONS.branch,
        href: PATH_DASHBOARD.company.root,
        isAdmin: true,
        adminLevel: 'system-admin',
        items: [
          {
            title: 'list',
            href: PATH_DASHBOARD.company.list,
            isAdmin: true,
            adminLevel: 'system-admin'
          },
          {
            title: 'create',
            href: PATH_DASHBOARD.company.create,
            isAdmin: true,
            adminLevel: 'system-admin'
          }
        ]
      },

      // BRANDS
      {
        title: 'brands',
        icon: ICONS.branch,
        href: PATH_DASHBOARD.brand.root,
        isAdmin: true,
        adminLevel: 'brand-admin',
        items: [
          {
            title: 'list',
            href: PATH_DASHBOARD.brand.list,
            isAdmin: true
          },
          {
            title: 'create',
            href: PATH_DASHBOARD.brand.create,
            isAdmin: true,
            adminLevel: 'company-admin'
          }
        ]
      },

      // BRANCHES
      {
        title: 'branches',
        icon: ICONS.branch,
        href: PATH_DASHBOARD.branch.root,
        isAdmin: true,
        adminLevel: 'branch-admin',
        items: [
          {
            title: 'list',
            href: PATH_DASHBOARD.branch.list,
            isAdmin: true,
            adminLevel: 'branch-admin'
          },
          {
            title: 'create',
            href: PATH_DASHBOARD.branch.create,
            isAdmin: true,
            adminLevel: 'brand-admin'
          }
        ]
      },

      // INVENTORY : EDIT
      // ----------------------------------------------------------------------
      {
        title: 'inventory',
        icon: ICONS.carousel,
        href: PATH_DASHBOARD.inventory.root,
        items: [
          {
            title: 'find vehicle',
            href: PATH_DASHBOARD.inventory.findVehicle,
            isAdmin: false
          },
          {
            title: 'add vehicle',
            // href: PATH_DASHBOARD.inventory.editVehicle,
            href: PATH_DASHBOARD.inventory.addVehicle,
            isAdmin: false
          },
          {
            title: 'bulk upload',
            href: PATH_DASHBOARD.inventory.bulkUploadVehicle,
            isAdmin: true
          }
        ]
      },
      {
        title: 'System',
        icon: ICONS.system,
        href: PATH_DASHBOARD.system.root,
        isAdmin: true,
        adminLevel: 'system-admin',
        items: [
          {
            title: 'Logs',
            href: PATH_DASHBOARD.system.logs,
            isAdmin: true,
            adminLevel: 'system-admin'
          }
        ]
      }

      // // MANAGEMENT : ADVERTISING
      // // ----------------------------------------------------------------------
      // {
      //   title: 'advertising',
      //   icon: ICONS.carousel,
      //   href: PATH_DASHBOARD.advertising.root,
      //   items: [
      //     {
      //       title: 'carsales',
      //       href: PATH_DASHBOARD.advertising.carsales
      //     },
      //     {
      //       title: 'facebook marketplace',
      //       href: PATH_DASHBOARD.advertising.facebook
      //     },
      //     {
      //       title: 'instagram',
      //       href: PATH_DASHBOARD.advertising.instagram
      //     }
      //   ]
      // },

      // INVENTORY : LEADS
      // ----------------------------------------------------------------------
      // {
      //   title: 'leads',
      //   icon: ICONS.ecommerce,
      //   href: PATH_DASHBOARD.lead.root,
      //   items: [
      //     {
      //       title: 'list',
      //       href: PATH_DASHBOARD.lead.list,
      //       isAdmin: false
      //     }
      //   ]
      // }
    ]
  },

  // TRADE-IN
  // ----------------------------------------------------------------------
  {
    subheader: 'trade in',
    items: [
      {
        title: 'pricing requests',
        icon: ICONS.elements,
        href: PATH_DASHBOARD.pricingRequest.root,
        isTradeInSpecialist: true,
        items: [
          {
            title: 'list',
            href: PATH_DASHBOARD.pricingRequest.list,
            isTradeInSpecialist: true
          }
        ]
      }
    ]
  },

  // Documentation
  // ----------------------------------------------------------------------
  {
    subheader: '',
    items: [
      {
        title: 'User Guide',
        href: PATH_DOCS.root,
        icon: ICONS.document,
        isAdmin: false
      }
    ]
  }

  // APP
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'Drive Cloud Apps',
  //   items: [
  //     {
  //       title: 'mail',
  //       href: PATH_DASHBOARD.mail.root,
  //       icon: ICONS.mail
  //     },
  //     {
  //       title: 'chat',
  //       href: PATH_DASHBOARD.chat.root,
  //       icon: ICONS.chat
  //     },
  //     {
  //       title: 'calendar',
  //       href: PATH_DASHBOARD.calendar,
  //       icon: ICONS.calendar
  //     }
  //   ]
  // }
];

export default sidebarConfig;
